var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTerrenoBaldio = function SvgTerrenoBaldio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7EDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 26C22.5 24.067 24.067 22.5 26 22.5C27.933 22.5 29.5 24.067 29.5 26V29.5H36.5V26C36.5 24.067 38.067 22.5 40 22.5C41.933 22.5 43.5 24.067 43.5 26V29.5H50.5V26C50.5 24.067 52.067 22.5 54 22.5C55.933 22.5 57.5 24.067 57.5 26V55.75C57.5 56.7165 56.7165 57.5 55.75 57.5H52.25C51.2835 57.5 50.5 56.7165 50.5 55.75V54H43.5V55.75C43.5 56.7165 42.7165 57.5 41.75 57.5H38.25C37.2835 57.5 36.5 56.7165 36.5 55.75V54H29.5V55.75C29.5 56.7165 28.7165 57.5 27.75 57.5H24.25C23.2835 57.5 22.5 56.7165 22.5 55.75V26ZM29.5 48.75H36.5V34.75H29.5V48.75ZM43.5 48.75H50.5V34.75H43.5V48.75Z",
    fill: "#AB00E7"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTerrenoBaldio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/terreno-baldio.4882a7fb.svg";
export { ForwardRef as ReactComponent };